module.exports = __webpack_public_path__ + "img/ppt.d3b1d720.png";